export default function DryWeatherIcon({ className }) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1092_1943)">
        <path
          d="M1.5 15H23.5"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 19H20.5"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 23H17.5"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 11C2.5 5.5 7 1 12.5 1C18 1 22.5 5.5 22.5 11"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1092_1943">
          <rect
            width="24"
            height="24"
            fill="inherit"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
